<template>
  <div class="container text-center">
    <h1 class="mb-[8px] text-[40px] text-[#d9534f]">404 - Page Not Found</h1>
    <p class="text-lg">Sorry, the page you’re looking for doesn’t exist or may have been moved.</p>
    <div class="text-center mt-3">
      <button
        class="btn main-button rounded-lg !text-black-100"
        @click="back"
      >
        Back
      </button>
    </div>
  </div>
</template>
  
<script>


export default {
  name: 'NotFound',
  methods: {

    back() {
      this.$router.go(-2)
    }
  },
};
</script>
  
<style scoped>
body {
  font-family: 'Arial', sans-serif;
  background-color: #f4f4f4;
  color: #333;
  text-align: center;
  padding: 50px;
  margin: 0;
}
</style>